




import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { ICurrentPage } from '~/store/types';
import LauncherEula from '~/components/Settings/LauncherEula.vue';

@Component({
  components: {
    LauncherEula,
  },
})
export default class LauncherEulaPage extends Vue {
  @Mutation updateCurrentPage!: (payload: ICurrentPage) => void;

  async created() {
    this.updateCurrentPage({
      title: 'Launcher EULA',
      backIcon: 'close',
    });
  }
}
